import React from 'react';
import CourseRecommendations from '../components/career/CourseRecommendations';

const CourseRecommendationsPage = () => {
  return <CourseRecommendations />;
};

export default CourseRecommendationsPage;
